// extracted by mini-css-extract-plugin
export var plp__divider = "plpProduct-module--plp__divider--RosrX";
export var plp__h1 = "plpProduct-module--plp__h1--V1K06";
export var plp__stat = "plpProduct-module--plp__stat--vOMHd";
export var plp__story = "plpProduct-module--plp__story--6rEkC";